import type { EvaluationStep } from './types';

import { RouteName } from '@/navigation/types';

// Maps each manager-assessment step to the route that renders its page, so every page's stepper
// can navigate to any other step from a single source of truth.
const STEP_ROUTES: Record<EvaluationStep, string> = {
    1: RouteName.ManagerAssessmentEvaluation,
    2: RouteName.ManagerAssessmentResults,
    3: RouteName.ManagerAssessmentPrepareMeeting,
    4: RouteName.ManagerAssessmentMeet,
};

export const getManagerAssessmentStepPath = (
    step: EvaluationStep,
    cycleInstanceId?: string,
): string => `${STEP_ROUTES[step]}/${cycleInstanceId ?? ''}`;

export const FIRST_STEP: EvaluationStep = 1;
export const LAST_STEP: EvaluationStep = 4;
const SURVEY_SUBMITTED_STEP: EvaluationStep = 2;

export const isManagerAssessmentSubmitted = (step?: number): boolean =>
    (step ?? 0) >= SURVEY_SUBMITTED_STEP;

// Normalizes a persisted managerAssessmentStep (which may be undefined for a fresh instance, or
// out of range) into a valid EvaluationStep, so callers can route to the reached step safely.
export const clampToManagerAssessmentStep = (step?: number): EvaluationStep => {
    if (!step || step < FIRST_STEP) {
        return FIRST_STEP;
    }

    return Math.min(step, LAST_STEP) as EvaluationStep;
};
